import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CRMType } from 'src/app/user-profile/shared/models';

@Component({
  selector: 'app-crm-synchronization-conversation-frequency',
  templateUrl: './crm-synchronization-conversation-frequency.component.html',
  styleUrls: ['./crm-synchronization-conversation-frequency.component.scss'],
})
export class CrmSynchronizationConversationFrequencyComponent implements OnInit {
  @Input() crmType: CRMType;
  @Input() conversationSyncFrequencies: {
    id: 'synchronous' | 'periodic';
    disabled: boolean;
    title: string;
    description: string;
  }[] = [];

  frequencyControl = new FormControl({ value: 'synchronous', disabled: true }, Validators.required);
  realTimeFrequency!: any;

  ngOnInit(): void {
    this.realTimeFrequency = this.conversationSyncFrequencies.find(({ id }) => id === 'synchronous');
  }
}
